"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PropertyMapping_1 = require("./PropertyMapping");
/**
 * Provides a builder for {@link IIriTemplate} variable mapping values.
 */
class MappingsBuilder {
    /**
     * Initializes a new instance of the {@link MappingBuilder} class.
     * @param {MappingsCollection} mappings IRI template variable mappings collection.
     */
    constructor(mappings) {
        this.mappings = mappings;
        this.result = {};
    }
    /**
     * Gets variable mappings in form of variable name - property IRI pairs.
     * @returns {IDictionary<string>}
     */
    get variableMappings() {
        const result = {};
        for (const mapping of this.mappings) {
            result[mapping.variable] = mapping.property.iri;
        }
        return result;
    }
    /**
     * Allows to add an IRI property value.
     * @param {string} property IRI of the property to be filled with value.
     * @returns {PropertyMapping}
     */
    withProperty(property) {
        const mapping = this.mappings.ofProperty(property).first();
        if (!mapping) {
            throw new Error(`Invalid mapping of property '${property}.`);
        }
        return new PropertyMapping_1.default(this, this.result, mapping);
    }
    /**
     * Allows to add a direct variable value.
     * @param {string} property IRI of the property to be filled with value.
     * @returns {PropertyMapping}
     */
    withVariable(variableName) {
        const mapping = this.mappings.ofVariableName(variableName).first();
        if (!mapping) {
            throw new Error(`Invalid mapping of variable name mapping '${variableName}.`);
        }
        return new PropertyMapping_1.default(this, this.result, mapping);
    }
    /**
     * Completes the variable values mappings in form of variable name - serialized value pairs.
     * @returns {IDictionary<string>}
     */
    complete() {
        return this.result;
    }
}
exports.default = MappingsBuilder;
//# sourceMappingURL=MappingsBuilder.js.map